<template>
  <div id="tst">
    <v-tooltip v-model="show" bottom>
      <v-btn :disabled="disableButton" :class="[disableButton ? 'c_disabled' : '']" slot="activator" @click.native="setPositionMenu($event)" icon small flat>
        <v-icon class="material-icons">touch_app</v-icon>
      </v-btn>
      <span>Opções de manifesto da nota</span>
    </v-tooltip>

    <v-menu
      v-model="menu"
      nudge-top="20"
      :position-x="menuX"
      :position-y="menuY"
      :close-on-content-click="false"
      bottom
      offset-y
    >
      <v-list id="options">
        <div id="title">Manifestar</div>

        <v-list-tile class="item" v-for="(item, index) in items" :key="index">
          <v-list-tile-title @click="vereficaOperacao(item)">
            <v-tooltip right>
              <div slot="activator">
                <v-icon style="font-size: 15px;">{{item.icon}}</v-icon>
                {{ item.title }}
              </div>

              <span>{{item.tooltip}}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      id="snack"
    >
      {{ text }}
      <v-btn color="orange" flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>

    <v-dialog
      v-show="eventoSelecionado && eventoSelecionado.hasOwnProperty('tpEvento') && dialog"
      v-model="dialog"
      @keydown.esc="dialog = false"
      width="500"
    >
      <v-card>
        <v-card-title class="grey lighten-2" primary-title style="font-size: 14px">
          <span>
            Justifique a manifestação:
            <strong>{{eventoSelecionado.title}}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-progress-linear v-if="carregando" color="teal" height="4" indeterminate style="z-index: 3;"></v-progress-linear>
        <v-card-text>
          <v-textarea
            v-model="eventoSelecionado['just']"
            auto-grow
            box
            counter="200"
            :rules="[rules.tam, rules.empty]"
            color="teal"
            validate-on-blur
            label="Justificativa"
            rows="1"
            ref="just"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn color="red" text="white" @click="validarJust(eventoSelecionado)">Manifestar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
export default {
  props: ["chave", "empresa", "component", "nota"],
  data: () => ({
    rules: {
      tam: value => {
        if (value && (value.length > 200 || value.length < 15)) {
          return "Justificativa necessita estar entre 15 à 200 caracteres";
        } else {
          return true;
        }
      },
      empty: value => !!value || `Necessário enviar uma justificativa`
    },
    eventoSelecionado: {},
    snackbar: false,
    y: "bottom",
    x: null,
    mode: "",
    timeout: 5000,
    text: "",
    menu: false,
    menuX: 0,
    menuY: 0,
    show: false,
    dialog: false,
    carregando: false
  }),
  computed: {
    items() {
      if(this.component.name.indexOf('CTE') != -1) {
        return [
          {
            title: "Desacordo",
            tooltip: "Manifestar a não realização de uma operação",
            icon: "cancel",
            tpEvento: "210240" // - Operação não realizada
          }
        ];
      }else {
        return [
          {
            title: "Confirmação da Operação",
            tooltip: "Confirmar uma operação concluida e bem sucedida",
            icon: "check_circle",
            tpEvento: "210200" // - Confirmação da Operação
          },
          {
            title: "Ciência da Operação",
            tooltip:
              "Efetua Ciência da operação para a SEFAZ \n e habilita o arquivamento da nota",
            icon: "adjust",
            tpEvento: "210210" // - Ciência da Operação
          },
          {
            title: "Desconhecimento da Operação",
            tooltip: "Manifestar desconhecimento de uma operação",
            icon: "help",
            tpEvento: "210220" // - Desconhecimento da Operação
          },
          {
            title: "Operação não realizada",
            tooltip: "Manifestar a não realização de uma operação",
            icon: "cancel",
            tpEvento: "210240" // - Operação não realizada
          }
        ];
      }
    },
    disableButton: function() {
      if(this.component.name.toLowerCase().indexOf("cte") != -1) {
        if(this.nota.item.manifestacao === 'Desacordo') {
          return true;
        }else {
          return false;
        }
      }
    },
  },
  methods: {
    vereficaOperacao: function(evento) {
      if (evento) {
        const tpEvento = evento.tpEvento;
        if (tpEvento == "210240") {
          //se for diferente de ciência da operação habilitar campo para justificar a operação
          this.eventoSelecionado = evento;
          this.dialog = true;
        } else {
          this.manifestar(evento);
        }
      }
    },
    validarJust: function(eventoSelecionado) {
      if(this.component.name.indexOf('CTE') != -1) {
        if (this.$refs.just.validate()) {
          this.carregando = true;
          this.desacordo(eventoSelecionado);
        } else {
          this.$refs.just.valid = false;
        }
      }else {
        if (this.$refs.just.validate()) {
          this.carregando = true;
          this.manifestar(eventoSelecionado);
        } else {
          this.$refs.just.valid = false;
        }
      }
    },
    manifestar: async function(evento) {
      const tpEvento = evento.tpEvento;
      const just = evento.hasOwnProperty("just") ? evento.just : undefined;
      this.service = new NfeService(this.$http);
      await this.service
        .manifestar(this.chave, tpEvento, this.empresa, just)
        .then(message => (this.text = message))
        .then(reset => {
          this.eventoSelecionado = {};
          this.eventoSelecionado["just"] = '';
          this.dialog = false;
          this.carregando = false;
        });
      if (this.text != "") {
        this.snackbar = true;
        this.menu = false;
      }
    },
    desacordo: async function(evento) {
      const just = evento.hasOwnProperty("just") ? evento.just : undefined;
      this.service = new CteService(this.$http);
      await this.service
        .desacordo(this.chave, this.empresa, just)
        .then(message => (this.text = message))
        .then(reset => {
          this.eventoSelecionado = {};
          this.eventoSelecionado["just"] = '';
          this.dialog = false;
          this.carregando = false;
        });
      if (this.text != "") {
        this.snackbar = true;
        this.menu = false;
      }
    },
    setPositionMenu: function(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    }
  }
};
</script>
<style scoped>
#snack {
  z-index: 9999 !important;
}
#content {
  display: inline-block;
}
#options {
  cursor: pointer;
}
.item:after {
  content: "";
  position: absolute;
  transition: all 0.5s linear;
  height: 2px;
  background-color: #25476a;
  width: 0%;
}
.item {
  transition: all 0.8s ease-in-out;
}
.item:hover {
  background-color: #eaeaea;
}
.item:hover:after {
  width: 100%;
  background-color: rgb(0, 150, 136);
}
#title {
  cursor: default;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  padding: 6px;
  font-family: "Quicksand", sans-serif;
  color: #25476a;
}

.v-btn {
  margin: 2px 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnManifestar/BtnManifestar.vue